import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "27d91b0c56681bc7bb41bd66174fcfc9.jpg",
    width: 1536,
    height: 1889
});